import { Injectable } from '@angular/core';
import { CommonService } from 'src/@services/common.service';
import { EndPoints } from 'src/@shared/enum';
import type { IdParam, JsonOrFormBody, JsonRecord } from './types/api-payloads.types';

@Injectable({
  providedIn: 'root',
})
export class CommonPagesPaymentService {
  constructor(private _cS: CommonService) {}

  GetPayment(PaymentId: IdParam) {
    return this._cS.API_GET(EndPoints.GetPayment + `?PaymentId=${PaymentId}`);
  }
  GetVendor(VendorId: IdParam) {
    return this._cS.API_GET(EndPoints.GetVendor + `?VendorId=${VendorId}`);
  }
  GetSiteVendor(VendorId: IdParam) {
    return this._cS.API_GET(EndPoints.GetSiteVendor + `?VendorId=${VendorId}`);
  }
  MapWithExistingVendor(formData: JsonOrFormBody) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.MapWithExistingVendor, formData, false, {
      headers: hd,
    });
  }
  unlinkVendor(PaymentId: IdParam) {
    return this._cS.API_POST(
      EndPoints.UnlinkVendor + `?PaymentId=${PaymentId}`
    );
  }
  GetQBOVendorDropdownList() {
    return this._cS.API_GET(EndPoints.GetQBOVendorDropdownList);
  }
  AddNewVendor(vendorBody: JsonRecord) {
    return this._cS.API_POST(EndPoints.AddNewVendor, vendorBody);
  }

  CreateBill(formData: JsonOrFormBody) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.CreateBill, formData, false, {
      headers: hd,
    });
  }

  UpdateBill(formData: JsonOrFormBody) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.UpdatePayment, formData, false, {
      headers: hd,
    });
  }

  getTagsDropdownList(siteId: IdParam) {
    return this._cS.API_GET(
      EndPoints.GetTagsDropdownlist + `?siteId=${siteId}`,
      false
    );
  }

  billApprove(paymentData: JsonRecord) {
    return this._cS.API_POST(EndPoints.BillApprove, paymentData);
  }

  updateQBOVendor(vendorData: JsonRecord) {
    return this._cS.API_POST(EndPoints.UpdateQBOVendor, vendorData);
  }
  saveInvestmentLiabilities(liabilities: JsonRecord) {
    return this._cS.API_POST(EndPoints.SaveInvestmentLiabilities, liabilities);
  }
  deletePayment(paymentId: IdParam) {
    return this._cS.API_DELETE(
      EndPoints.DeletePayment + `?paymentId=${paymentId}`
    );
  }

  GetSiteVendorDropdownList(SiteId: IdParam, searchText: string = '') {
    return this._cS.API_GET(
      EndPoints.GetSiteVendorDropdownList +
        `?SiteId=${SiteId}&searchText=${searchText}`
    );
  }

  PreviewQBOAttachment(QBOAttachmentId: IdParam) {
    return this._cS.API_GET(
      EndPoints.PreviewQBOAttachment + `?QBOAttachmentId=${QBOAttachmentId}`,
      false
    );
  }

  UploadW9AttachmentFile(formData: JsonOrFormBody) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(
      EndPoints.UploadW9AttachmentFile,
      formData,
      false,
      {
        headers: hd,
      }
    );
  }

  PaybevBillAttachment(formData: JsonOrFormBody) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.PaybevBillAttachment, formData, false, {
      headers: hd,
    });
  }

  GetExpenseDetail(expenseID: IdParam) {
    return this._cS.API_GET(
      EndPoints.GetExpenseDetail + `?expenseID=${expenseID}`
    );
  }

  updateExpense(expenseData: JsonRecord) {
    return this._cS.API_POST(EndPoints.UpdateExpense, expenseData);
  }

  GetCreditDetail(CreditID: IdParam) {
    return this._cS.API_GET(
      EndPoints.GetCreditDetail + `?CreditsId=${CreditID}`
    );
  }
  GetRefundDetail(refundID: IdParam) {
    return this._cS.API_GET(
      EndPoints.GetRefundsById + `?refundsId=${refundID}`
    );
  }
  updateRefund(refundData: JsonRecord) {
    return this._cS.API_POST(EndPoints.UpdateRefund, refundData);
  }
  GetDepositDetail(DepositID: IdParam) {
    return this._cS.API_GET(
      EndPoints.GetDepositDetail + `?depositId=${DepositID}`
    );
  }
  updateDeposit(DepositData: JsonRecord) {
    return this._cS.API_POST(EndPoints.UpdateDeposit, DepositData);
  }

  updateCredit(CreditData: JsonRecord) {
    return this._cS.API_POST(EndPoints.UpdateCredit, CreditData);
  }

  GetInternalTransferDetails(InternalTransfId: IdParam) {
    return this._cS.API_GET(
      EndPoints.GetInternalTransferDetails + `?TransferId=${InternalTransfId}`
    );
  }

  UpdateInternalTransfer(transferData: JsonRecord) {
    return this._cS.API_POST(EndPoints.UpdateInternalTransfer, transferData);
  }

  resyncDepositData(depositId: IdParam) {
    return this._cS.API_GET(
      EndPoints.ResyncDepositData + `?depositId=${depositId}`
    );
  }
  resyncCreditData(creditId: IdParam) {
    return this._cS.API_GET(
      EndPoints.ResyncCreditData + `?CreditsId=${creditId}`
    );
  }
  resyncExpenseData(expenseId: IdParam) {
    return this._cS.API_GET(
      EndPoints.ResyncExpenseData + `?expenseID=${expenseId}`
    );
  }
  resyncRefundData(refundId: IdParam) {
    return this._cS.API_GET(
      EndPoints.ResyncRefundData + `?refundsId=${refundId}`
    );
  }
  resyncInternalTransferData(transferId: IdParam) {
    return this._cS.API_GET(
      EndPoints.ResyncInternalTransferData + `?TransferId=${transferId}`
    );
  }
  resyncPaymentData(paymentId: IdParam) {
    return this._cS.API_GET(
      EndPoints.ResyncPaymentData + `?PaymentId=${paymentId}`
    );
  }
}
